/**
* Copyright by:

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/
import { formatDate } from '@angular/common';
import { Inject, Injectable, LOCALE_ID } from '@angular/core';
export enum DateFormat {
  shortDate,
  shortTime,
  short,
  long,
  customShortDateAndTime
}
@Injectable({
  providedIn: 'root'
})
export class CustomDateFormatService {
  constructor(@Inject(LOCALE_ID) public locale: string) {}

  formatDate(date: string, dateFormat: DateFormat = DateFormat.long): string {
    if (dateFormat == DateFormat.shortDate) {
      return formatDate(date, 'shortDate', this.locale);
    } else if (dateFormat == DateFormat.shortTime) {
      return formatDate(date, 'shortTime', this.locale);
    } else if (dateFormat == DateFormat.short) {
      return formatDate(date, 'short', this.locale);
    } else if (dateFormat == DateFormat.customShortDateAndTime) {
      return formatDate(date, 'shortDate', this.locale) + ', ' + formatDate(date, 'shortTime', this.locale);
    } else {
      return (
        formatDate(date, 'fullDate', this.locale) + ' ' + formatDate(date, 'shortTime', this.locale)
      );
    }
  }
}
